/*
Color utility
*/

const lightenDarkenColor = function (colorCode, amount) {
  let pound = '';
  if (colorCode.indexOf('#') >= 0) {
    colorCode = colorCode.slice(1);
    pound = '#';
  }
  const num = parseInt(colorCode, 16);
  amount = parseInt((255 * amount) / 100);

  const R = Math.min(Math.max(0, (num >> 16) + amount), 255);
  const G = Math.min(Math.max(0, ((num >> 8) & 0xff) + amount), 255);
  const B = Math.min(Math.max(0, (num & 0xff) + amount), 255);

  return pound + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1);
};

export default {
  lighten(colorCode, amount) {
    return lightenDarkenColor(colorCode, amount);
  },

  darken(colorCode, amount) {
    return lightenDarkenColor(colorCode, amount * -1);
  }
};
